import { render } from "./CoursesList.vue?vue&type=template&id=73097708&scoped=true"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"

import "./CoursesList.vue?vue&type=style&index=0&id=73097708&scoped=true&lang=css"
import "./CoursesList.vue?vue&type=style&index=1&id=73097708&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73097708"]])

export default __exports__